import React from 'react';
import cn from 'clsx';

import Link from '../../../../library/link/link';

import { Maybe } from '../../../../shared/types/graphql-types';

import styles from './product-brand-logo.scss';

interface ProductBrandLogoProps {
  brand: Maybe<string> | undefined;
  brandLogoUrl: string;
  className?: string;
  link?: string;
}

function ProductBrandLogo(props: ProductBrandLogoProps) {
  const { brand, brandLogoUrl, className = '', link } = props;

  if (brandLogoUrl) {
    return link ? (
      <Link className={`${className || ''} product-brand-logo`} to={link}>
        <img
          alt={`${brand} Logo`}
          aria-label={`${brand} Logo`}
          className={styles['brand-logo']}
          src={brandLogoUrl}
        />
      </Link>
    ) : (
      <img
        alt={`${brand} Logo`}
        aria-label={`${brand} Logo`}
        className={cn(
          styles['brand-logo'],
          `${className || ''} product-brand-logo`
        )}
        src={brandLogoUrl}
      />
    );
  } else {
    return null;
  }
}

export default ProductBrandLogo;
